import { createSelector } from '@ngrx/store';

import {
  createListFeatureKey,
  State,
} from '../../reducers/create-list/create-list.reducer';
import * as store from '../../store';

export const selectCreateListState = createSelector<
  store.State,
  [store.ProductListState],
  State
>(store.selectProductListState, (state) => state[createListFeatureKey]);

export const selectListItemsAndType = createSelector(
  selectCreateListState,
  (state) => {
    return {
      items: state.listItems,
      type: state.listType,
    };
  },
);
